import { combineReducers } from "redux";
import samples from "./Samples";
import form from "./Form";
import login from "./Login";
import profile from "./Profile";
import user from "./User";
import tags from "./Tags";
import vendors from "./Vendors";
import serviceWorker from "./serviceWorker";
import fileReducer from "./Files";
import layoutReducer from "./layoutReducer";

const AppReducer = combineReducers({
  login,
  profile,
  samples,
  form,
  user,
  tags,
  vendors,
  serviceWorker,
  fileReducer,
  layoutReducer
});

export default AppReducer;
